"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = require("prop-types");
var _browserRum = require("@datadog/browser-rum");
var _actions = require("../actions");
var _selectors = require("../selectors");
var _package = _interopRequireDefault(require("../../../../apps/chat-list-web/package.json"));
var _package2 = _interopRequireDefault(require("../../../../apps/chat-list-web-next/package.json"));
var _package3 = _interopRequireDefault(require("../../../../apps/chat-adview-web/package.json"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Datadog = function Datadog(_ref) {
  var app = _ref.app,
    dataDogVariant = _ref.dataDogVariant;
  (0, _react.useEffect)(function () {
    if (dataDogVariant) {
      var DATADOG_APP_ID, DATADOG_CLIENT_TOKEN, VERSION_APP;
      if (app === 'chat-list-web-next') {
        DATADOG_APP_ID = "5a1cc1b5-76a4-429a-8b7e-d91895160dd1";
        DATADOG_CLIENT_TOKEN = "pubd23a619bb636f6dd881e5c8dac7b72b2";
        VERSION_APP = _package2["default"].version;
      } else if (app === 'chat-list-web') {
        DATADOG_APP_ID = "0e0698ce-190f-48ca-9dc5-7208a477ed1a";
        DATADOG_CLIENT_TOKEN = "pub220c29a982e24f7dcb06876682e91b7f";
        VERSION_APP = _package["default"].version;
      } else if (app === 'chat-adview-web') {
        DATADOG_APP_ID = "";
        DATADOG_CLIENT_TOKEN = "";
        VERSION_APP = _package3["default"].version;
      }
      if ("production" === 'production' && DATADOG_APP_ID && DATADOG_CLIENT_TOKEN) {
        _browserRum.datadogRum.init({
          applicationId: DATADOG_APP_ID,
          clientToken: DATADOG_CLIENT_TOKEN,
          site: 'datadoghq.com',
          service: app,
          env: 'prod',
          version: VERSION_APP,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input'
        });
      }
    }
  }, [app, dataDogVariant]);
  return null;
};
Datadog.propTypes = {
  app: _propTypes.string.isRequired,
  dataDogVariant: _propTypes.bool.isRequired
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    dataDogVariant: (0, _selectors.isFrontDatadog)(state)
  };
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps)(Datadog);